import { useTranslation } from 'react-i18next'
import { IdCardIcon } from './icons/IdCardIcon'

interface IdentityCardProps {
  firstName: string
  lastName: string
  pesel: string
}

export function IdentityCard({
  firstName,
  lastName,
  pesel,
}: IdentityCardProps) {
  const { t } = useTranslation()

  return (
    <div className='flex items-center px-4'>
      <div className='flex-shrink-0 pr-12'>
        <IdCardIcon className='w-12 h-12' />
      </div>

      <div className='flex-1 grid grid-cols-3'>
        <div>
          <div className='text-sm text-gray-600 mb-0.5'>
            {t('summary.identity.name')}:
          </div>
          <div className='font-semibold text-gray-900'>{firstName}</div>
        </div>

        <div>
          <div className='text-sm text-gray-600 mb-0.5'>
            {t('summary.identity.lastName')}:
          </div>
          <div className='font-semibold text-gray-900'>{lastName}</div>
        </div>

        <div>
          <div className='text-sm text-gray-600 mb-0.5'>
            {t('summary.identity.pesel')}:
          </div>
          <div className='font-semibold text-gray-900'>{pesel}</div>
        </div>
      </div>
    </div>
  )
}
